import { Component, Vue, Watch } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'

import api from '@/helpers/fetch'
import Fuse from 'fuse.js'
let fuse = new Fuse([], {})

library.add(faTrashAlt, faEdit)

@Component({
	components: {
		Loader,
	},
})
export default class DomainMarketSectors extends Vue {
	loading = false
	modalLoading = false
	options = [] as Array<any>
	filter = ''

	form = {
		id: '',
		name: '',
		nickname: '',
	}

	get filteredOptions() {
		// @ts-ignore
		return this.filter.length
			? fuse.search(this.filter).map(({ item }) => item)
			: this.options
	}

	async init() {
		this.options.length = 0

		this.loading = true
		const res = await api.get('/api/market-sectors')
		this.loading = false
		this.options.length = 0
		this.options.push(
			...res.data.map((option) => {
				const hasTrial = option.thermometers_aggregate.aggregate.count > 0
				Object.assign(option, { loading: false, hasTrial: hasTrial })
				return option
			}),
		)
		// @ts-ignore
		fuse = new Fuse(this.options, {
			keys: ['name'],
		})
	}

	clearForm() {
		this.form.id = ''
		this.form.name = ''
		this.modalLoading = false
	}

	openEdit(sector) {
		this.form.id = sector.id
		this.form.name = sector.name
		this.$bvModal.show('modal-edit-sector')
	}

	openNew() {
		this.clearForm()
		this.$bvModal.show('modal-new-sector')
	}

	async saveEdit() {
		if (!this.form.name) {
			this.$bvToast.toast(`O campo 'nome' é obrigatório!`, {
				title: 'Alerta!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'warning',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			try {
				this.modalLoading = true
				const sector = this.options.find(
					(sector) => sector.id === this.form.id,
				)

				const res = await api.post(
					'/api/market-sectors/' + sector.id,
					this.form,
				)
				if (res.ok) {
					sector.name = this.form.name
					this.$bvModal.hide('modal-edit-sector')
					this.$bvToast.toast('Escritório salvo com sucesso!', {
						title: 'Sucesso!',
						autoHideDelay: 2500,
						appendToast: true,
						variant: 'success',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				} else {
					this.$bvToast.toast('Ocorreu um erro inesperado!', {
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				}
			} catch (error) {
				this.$bvToast.toast(
					'Ocorreu um erro ao processar a requisição!',
					{
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					},
				)
			} finally {
				this.modalLoading = false
			}
		}
	}

	async saveNew() {
		if (!this.form.name) {
			this.$bvToast.toast(`O campo 'nome' é obrigatório!`, {
				title: 'Alerta!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'warning',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			try {
				this.modalLoading = true
				const res = await api.post('/api/market-sectors/', this.form)
				if (res.ok) {
					this.options.push({
						id: res.data.id,
						name: this.form.name,
						loading: false,
					})

					// @ts-ignore
					fuse = new Fuse(this.options, {
						keys: ['name'],
					})

					this.$bvModal.hide('modal-new-sector')
					this.$bvToast.toast('Escritório adicionado com sucesso!', {
						title: 'Sucesso!',
						autoHideDelay: 2500,
						appendToast: true,
						variant: 'success',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				} else {
					this.$bvToast.toast('Ocorreu um erro inesperado!', {
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					})
				}
			} catch (error) {
				this.$bvToast.toast(
					'Ocorreu um erro ao processar a requisição!',
					{
						title: 'Erro!',
						autoHideDelay: 5000,
						appendToast: true,
						variant: 'danger',
						toaster: 'b-toaster-top-center',
						solid: true,
					},
				)
			} finally {
				this.modalLoading = false
			}
		}
	}

	async deleteSector(sector, index) {
		const res = await api.delete('/api/market-sectors/', sector)
		if (res.ok) {
			this.options.splice(index, 1)
			this.filter = this.filter.length ? '' : this.filter
			this.$bvToast.toast(
				'Setor excluído com sucesso!',
				{
					title: 'Sucesso!',
					autoHideDelay: 2500,
					appendToast: true,
					variant: 'success',
					toaster: 'b-toaster-top-center',
					solid: true,
				},
			)
		} else {
			this.$bvToast.toast('Ocorreu um erro inesperado!', {
				title: 'Erro!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'danger',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		}
	}

	mounted() {
		this.init()
	}
}
